import React from 'react';
import { useLoadScript } from '@react-google-maps/api';

import PageLayout from '../../components/PageLayout';
import Country from '../../components/master/Country';

interface MasterPageProps {
  onLogout?: () => void;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const CountryPage: React.FC<MasterPageProps> = ({ onLogout, currentPage, onNavigate }) => {

  return (
    <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
      <Country />
    </PageLayout>
  );
};

export default CountryPage;
